import { v4 as uuidv4 } from 'uuid';
import { MEDIA_BREAKPOINT_ENTRIES } from '@utils/AppWindow/app-window.constants';

function generateUniqueId() {
  return uuidv4();
}

function isMobile(currentBreakpoint, mobileMaxMediaBreakpoint) {
  const mediaBreakpoints = MEDIA_BREAKPOINT_ENTRIES.map(curr => curr[1]);
  const indexOfCurrent = mediaBreakpoints.indexOf(currentBreakpoint);
  const indexOfMobileMax = mediaBreakpoints.indexOf(mobileMaxMediaBreakpoint);
  
  return (indexOfCurrent <= indexOfMobileMax);
}

function removeExternalLoader() {
  const loaderEl = document.querySelector('.js-external-loader');

  if (!loaderEl) {
    return;
  }

  loaderEl.parentNode.removeChild(loaderEl);
}

function getSizeFromResizeObserverEntry(entry) {
  if (!entry.contentBoxSize) {
    return {
      width: entry.contentRect.width,
      height: entry.contentRect.height,
    };
  }

  const { 
    inlineSize: width, 
    blockSize: height, 
  } = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;

  return { width, height };
}

const tagBody = '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*';

const tagOrComment = new RegExp(
  `${'<(?:'
  + '!--(?:(?:-*[^->])*--+|-?)' // Comment body.
  + '|script\\b'}${tagBody}(/|>[\\s\\S]*?</script\\s*)` // <script...>...</script> & <script.../>
  + `|style\\b${tagBody}(/|>[\\s\\S]*?</style\\s*)` // <style...>...<style> & <style.../>
  + `|iframe\\b${tagBody}(/|>[\\s\\S]*?</iframe\\s*)` // <iframe...>...<iframe> & <iframe.../>
  + ')>',
  'gi',
);

const sanitizeHTML = html => html.replace(tagOrComment, '');

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' });

function formatCurrency(value) {
  return currencyFormatter.format(value);
}

const fromatTotalDamageValue = (value) => {
  const { length } = value;
  if (length > 11) {
    // For millions
    return `${value.substring(0, length - 9)} M`;
  } if (length > 4) {
    // For hundreds of thousands
    return `${value.substring(0, length - 7)} K`;
  } 
  if (length > 3) {
    // For thousands
    return `${value.substring(0, length - 8)} K`;
  } 
  // For values less than 1000
  return value;
}

export {
  formatCurrency,
  generateUniqueId,
  isMobile,
  removeExternalLoader,
  getSizeFromResizeObserverEntry,
  fromatTotalDamageValue,
  sanitizeHTML,
}